export default __webpack_public_path__ + "images/88e19f3ec6389a08c0fee74bb06bbb1b-climbing_small.webp";